import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Paper, 
  BottomNavigation as MuiBottomNavigation, 
  BottomNavigationAction
} from '@mui/material';
import { 
  Dashboard, 
  ListAlt,
  Payments
} from '@mui/icons-material';

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const getActiveValue = () => {
    const path = location.pathname;
    if (path === '/') return 0;
    if (path.includes('/requests') && !path.includes('/requests/')) return 1;
    if (path === '/integrate-stripe') return 2;
    return 0;
  };
  
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/requests');
        break;
      case 2:
        navigate('/integrate-stripe');
        break;
      default:
        navigate('/');
    }
  };

  // Don't show navigation on auth pages
  if (location.pathname === '/login' || location.pathname === '/register') {
    return null;
  }

  // Hide on specific detail pages to avoid UI clutter 
  if (location.pathname.includes('/requests/')) {
    return null;
  }

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000,
        borderTop: `1px solid rgba(16, 29, 59, 0.2)`,
        height: 64
      }} 
      elevation={0}
    >
      <MuiBottomNavigation
        showLabels
        value={getActiveValue()}
        onChange={handleChange}
        sx={{
          height: '100%',
          backgroundColor: '#FFFFFF',
          '& .MuiBottomNavigationAction-root': {
            color: 'rgba(16, 29, 59, 0.6)',
            minWidth: 'auto',
            '&.Mui-selected': {
              color: '#00AB9B'
            }
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '14px',
            fontWeight: 400,
            transition: '0.3s ease',
            '&.Mui-selected': {
              fontSize: '14px',
              fontWeight: 700
            }
          }
        }}
      >
        <BottomNavigationAction 
          label="Dashboard" 
          icon={<Dashboard />} 
        />
        <BottomNavigationAction 
          label="Requests" 
          icon={<ListAlt />} 
        />
        <BottomNavigationAction 
          label="Payments" 
          icon={<Payments />} 
        />
      </MuiBottomNavigation>
    </Paper>
  );
};

export default BottomNavigation; 